import { render } from "./ArrowLink.vue?vue&type=template&id=628ca01c"
import script from "./ArrowLink.vue?vue&type=script&lang=js"
export * from "./ArrowLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/ArrowLink.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "628ca01c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('628ca01c', __exports__)) {
    api.reload('628ca01c', __exports__)
  }
  
  module.hot.accept("./ArrowLink.vue?vue&type=template&id=628ca01c", () => {
    api.rerender('628ca01c', render)
  })

}


export default __exports__